<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="forgot-password-view">
    <div class="forgot-wrap">
      <div class="forgot-header">
        <div class="icon-ajuntament" />
      </div>
      <div class="forgot-body">
        <div class="forgot-title">{{ $t('password_forgot') }}</div>
        <div class="forgot-explain">{{ $t('forgot_desc') }}</div>
        <div class="forgot-input-wrapper">
          <label class="forgot-input-label">{{ $t('email') }}</label>
          <input
            v-model="emailInput"
            class="forgot-input"
            :class="hasEmailError && 'error'"
            type="text"
            :placeholder="$t('email_ex')"
          >
        </div>
      </div>
      <div class="forgot-footer">
        <div class="forgot-btn" @click="recoverUserFunc">{{ $t('confirm') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { recoverUser } from '@/services/user-api'
export default {
  components: {},
  props: {},
  data() {
    return {
      emailInput: '',
      hasEmailError: false,
    }
  },
  computed: {},
  watch: {
    emailInput() {
      this.hasEmailError = false
    },
  },
  methods: {
    /**
     * Update the current route with new params if current page is different
     * @param {String} routeName Name of page that user want's to navigate
     * @public This is a public method
     */
    routeChange(routeName) {
      if (this.$route.name !== routeName) this.$router.push({ name: routeName })
    },
    recoverUserFunc() {
      let reg = /[^\s]*@[a-z0-9.-]*/i
      if ((this.emailInput === '' || !reg.test(this.emailInput)) && !this.hasEmailError) {
        this.hasEmailError = true
      }
      if (!this.hasEmailError) {
        recoverUser(this.emailInput).then(resp => {
          if (resp.code === 200) {
            sessionStorage.setItem('recoverEmail', this.emailInput)
            this.routeChange('EmailSend')
          }
        })
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.forgot-password-view
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  min-height: "calc(100vh - %s - %s - %s)" % ($header-height $subheader-height $footer-height)
  background-color: $very-light-grey

.forgot-wrap
  padding: vh(20px) vw(24px)
  width: vw(500px)
  border-radius: 8px
  background-color: #fff
  box-shadow: 0 4px 80px rgba(0, 0, 0, 0.05)

.forgot-header
  display: flex
  justify-content: space-between
  margin-bottom: vh(48px)

  .icon-ajuntament
    width: vw(176px)
    height: vw(45px)
    background-image: url("~@/assets/logos/logo-ajuntament-barcelona-rounded.svg")
    background-position: center center
    background-size: cover
    background-repeat: no-repeat

    .mobile &
      height: vh(90px)

.forgot-title
  m-font-size(32, 45)
  margin-bottom: vh(20px)
  font-weight: 600

.forgot-explain
  font-size(16, 20)
  margin-bottom: vh(20px)

.forgot-input-wrapper
  margin-bottom: vh(36px)
  width: 100%

.forgot-input-label
  m-font-size(14, 20)
  display: block
  margin-bottom: vh(8px)
  color: $grey

.forgot-input
  position: relative
  padding: 0
  padding-right: vw(12px)
  padding-left: vw(12px)
  width: 100%
  height: vh(48px)
  outline: none
  border: 1px solid $grey
  border-radius: 4px
  background-color: $light-grey
  color: #000
  font-weight: 600

  &::placeholder
    color: $grey
    font-weight: 400

  &.error
    border: 2px solid $warning

  .mobile &
    height: vh(60px)

.forgot-footer
  margin-top: vh(48px)

.forgot-btn
  m-font-size(14, 20)
  display: flex
  justify-content: center
  align-items: center
  padding: vw(10px)
  width: 100%
  border-radius: 4px
  background-color: #000
  color: #fff
  cursor: pointer
</style>